
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useEffect, useMemo, useCallback } from 'react';
import dynamic from 'next/dynamic';
import { sub } from 'date-fns';
import LoadingSpinner from '../components/LoadingSpinner';
import RelatedLinks from '../components/RelatedLinks';
import { getGraphData, getSummary } from '../lib/dbFetcher';
const MyChart = dynamic(() => import('../components/MyChart'), { ssr: false });
const StatisticsSummary = dynamic(() => import('../components/StatisticsSummary'), { ssr: false });
// const fetchGraphData = async (from, to) => {
//     const response = await fetch('/api/db', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             from,
//             to,
//             type: 'graph'
//         })
//     });
//     const result = await response.json();
//     setGraphData(result);
// };
// const fetchSummary = async (to) => {
//     const response = await fetch('/api/db', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             date: to,
//             type: 'summary'
//         })
//     });
//     const result = await response.json();
//     setSummaryData(result);
// };
async function getServerSideProps(context) {
    // Fetch data based on query parameters
    let { from, to } = context.query;
    if (from)
        from = new Date(from);
    if (to)
        to = new Date(to);
    if (!from && !to) {
        to = new Date();
        from = sub(to, { days: 7 });
    }
    else if (!from && to) {
        from = sub(new Date(to), { days: 7 });
    }
    else if (!to && from) {
        to = new Date();
    }
    // Every uncached hit runs two Postgres round trips, and each Lambda
    // instance opens its own pool (lib/prisma.js, max 3) against a server with
    // max_connections=100. A crawler walking the sitemap spins up dozens of
    // instances at once and the DB starts refusing with 53300 "too many
    // clients already", which surfaces as a 500 on this page. The underlying
    // data is only written every 5 minutes by the ingest cron, so serve it
    // from the CDN and let the DB see one request per window instead of one
    // per visitor.
    context.res.setHeader('Cache-Control', 'public, s-maxage=300, stale-while-revalidate=3600');
    // A DB blip should degrade to the "no data" state the chart already knows
    // how to render, not take the whole page down. A 500 here is also an SEO
    // problem: Search Console reports it as a server error.
    let graphData;
    let summaryData;
    try {
        graphData = await getGraphData(from, to);
        summaryData = await getSummary(to);
    }
    catch (error) {
        console.error('Error loading statistics:', error);
        context.res.setHeader('Cache-Control', 'no-store');
        graphData = {
            data: [],
            averageWaitTime: 0,
            formattedAverageWaitTime: '',
            error: 'No data available'
        };
        summaryData = { targetDate: to.toString(), summary: {} };
    }
    return {
        props: {
            initialGraphData: graphData,
            initialSummaryData: summaryData
        }
    };
}
function Statistics({ initialGraphData, initialSummaryData }) {
    const [graphData] = useState(initialGraphData);
    const [summaryData] = useState(initialSummaryData);
    const [from, setFrom] = useState(null);
    const [to, setTo] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleDateChange = useCallback((dateType, date) => {
        const newDate = new Date(date);
        const formattedDate = encodeURIComponent(newDate.toISOString());
        if (dateType === 'from') {
            setLoading(true);
            //hide .react-datepicker-popper
            document
                .querySelector('.react-datepicker-popper')
                ?.classList.add('hidden');
            window.location.href = `/statistics?from=${formattedDate}&to=${encodeURIComponent(to.toISOString())}`;
        }
        else {
            setLoading(true);
            document
                .querySelector('.react-datepicker-popper')
                ?.classList.add('hidden');
            window.location.href = `/statistics?from=${encodeURIComponent(from.toISOString())}&to=${formattedDate}`;
        }
    }, [setLoading, from, to]); // Add any other dependencies used inside the function
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const toParam = urlSearchParams.get('to')
            ? new Date(urlSearchParams.get('to'))
            : new Date();
        const fromParam = urlSearchParams.get('from')
            ? new Date(urlSearchParams.get('from'))
            : sub(toParam, { days: 7 });
        setFrom(fromParam);
        setTo(toParam);
    }, []);
    const memoizedChart = useMemo(() => (<MyChart data={graphData} selectedFrom={from} setSelectedFrom={setFrom} fromOnChange={(date) => handleDateChange('from', date)} selectedTo={to} setSelectedTo={setTo} toOnChange={(date) => handleDateChange('to', date)}/>), [graphData, from, to, handleDateChange]);
    return (<>
            {loading && <LoadingSpinner />}
            <div className="bg-white p-4 my-4 sm:rounded">
                {from && to && (<>
                        <StatisticsSummary data={summaryData} selectedDate={to} setSelectedDate={setTo} onChange={(date) => handleDateChange('to', date)}/>
                        {memoizedChart}
                    </>)}
            </div>

            <RelatedLinks links={[
            {
                href: '/travel-times',
                labelKey: 'link_wait_by_day'
            },
            {
                href: '/blog/best-time-to-pass-cph-security',
                labelKey: 'link_best_time'
            },
            {
                href: '/blog/cph-busiest-times',
                labelKey: 'link_busiest'
            }
        ]}/>
        </>);
}
export default Statistics;

    async function __Next_Translate__getServerSideProps__1a1723ec6ce__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/statistics',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1723ec6ce__ as getServerSideProps }
  